<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <form @submit.prevent="send" class="vx-col w-11/12 md:w-3/5 lg:w-2/5 sm:m-0 m-4">
      <vx-card class="rounded p-5 sm:p-10 sm:px-20 w-full">
        <div class="vx-card__title mb-10">
          <h4 class="text-center text-3xl sm:text-4xl mb-4">Forgot Password</h4>
          <p class="text-center text-sm">Enter your email address and we'll send you the instructions to reset your password</p>
        </div>
        <div>
          <ResponseAlert ref="response" />
          <div class="my-5">
            <vs-input
                v-validate="'required|email'" 
                name="email"
                icon-no-border
                icon="icon icon-user"
                icon-pack="feather"
                placeholder="Input your email"
                v-model="models.email"
                class="w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <vs-button button="submit" class="w-full mb-3">Send</vs-button>
          <div class="text-center">
            <router-link to="/login">Back</router-link>
          </div>
        </div>
      </vx-card>
    </form>
  </div>
</template>

<script>
export default{
  data() {
    return {
      models: {
        email: "",
      }
    }
  },
  methods: {
    send(){
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$axios.post('auth/forgot-password', this.models)
          .then(() => {
						this.$showToast('Success', `Please check your email to get new instructions`)
            this.$router.push('/login')
          })
          .catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
        }
      });
    },
  }
}
</script>
